import React from 'react';

export const getTextFromNode = (node: React.ReactNode) => {
  if (typeof node === 'string') {
    return node;
  }

  if (
    typeof node === 'number' ||
    typeof node === 'boolean' ||
    typeof node === 'bigint'
  ) {
    return node.toString();
  }

  if (node === null || node === undefined) {
    return '';
  }

  if (isIterable(node)) {
    return Array.from(node).map(getTextFromNode).join('');
  }

  if (
    typeof node === 'object' &&
    'props' in node &&
    node.props &&
    node.props.children !== undefined
  ) {
    return getTextFromNode(node.props.children);
  }

  return '';
};

const isIterable = (
  node: React.ReactNode
): node is Iterable<React.ReactNode> => {
  return typeof node[Symbol.iterator] === 'function';
};
